import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { SortCondition } from "../../Pages/Measure/VisibilityDependency/SortCondition";
import { RadioButtonComponent } from "../../Components/RadioButtonComponent";
import { app } from "../App";
import { DropDownComponentProps, DropDownComponent } from "../../Components/DropDownComponent";
import { IDropdown } from "../../Components/Interfaces/IDropdown";
import { ITreeField } from "./ITreeField";


export class SortFieldModel {
    fieldName: string;
    name: string;
}

export type GridViewSelectSortProps = {
    model: SortCondition;
    availableFields: ITreeField;
}

export class GridViewSelectSort extends JSXComponent {
    props: GridViewSelectSortProps;
    dropdownFirst: IDropdown;
    dropdownSecond: IDropdown;
    items: SortFieldModel[];

    constructor(props: GridViewSelectSortProps) {
        super(props);
        this.items = [];
        this.createItemsFromFields();
    }

    createItemsFromFields = () => {
        for (let field of this.props.availableFields.childs) {
            if (field.childs) {
                for (let child in field.childs.sort((a, b) => (a.name > b.name) ? 1 : -1)) {
                    this.items.push(this.createFieldModel(field.name, field.childs[child]));
                }
            }
        }
    }

    createFieldModel = (parentName: string, item: ITreeField): SortFieldModel => {
        let model = new SortFieldModel();
        model.fieldName = item.fieldName;
        model.name = parentName + ": " + item.name;
        return model;
    }

    private onFirstChange = (control: DropDownComponent) => {
        if (control.getValue() != "undefined")
            this.props.model.sortFirst = control.getValue();
        else
            this.props.model.sortFirst = "";
    }
    private onSecondChange = (control: DropDownComponent) => {
        if (control.getValue() != "undefined")
            this.props.model.sortSecond = control.getValue();
        else
            this.props.model.sortSecond = "";
    }

    onSortTypeSelected = (event: Event) => {
        let inputElem = event.target as HTMLInputElement;
        let value = inputElem.value;

        this.setSortTypeValue(inputElem, parseInt(value));
    }

    setSortTypeValue(inputElement: HTMLInputElement, value: number) {
        if (inputElement.classList.contains("sort-first"))
            this.props.model.sortFirstAsc = value;
        else
            this.props.model.sortSecondAsc = value;
    }

    element: HTMLElement;

    getElement = () => {
        let dropdownFirstProps: DropDownComponentProps = {
            id: app.createRadomizedLetters(10),
            displayProperty: "name",
            valueProperty: "fieldName",
            childrenProperty: "childs",
            expandAll: false,
            items: this.props.availableFields.childs,
            onChange: this.onFirstChange,
            disableSort: true,
            selectedValue: this.props.model?.sortFirst,
            name: Resources.Common.sortFirstColumnLabel
        }
        this.dropdownFirst = new DropDownComponent(dropdownFirstProps);

        let dropdownSecondProps: DropDownComponentProps = {
            id: app.createRadomizedLetters(10),
            displayProperty: "name",
            valueProperty: "fieldName",
            childrenProperty: "childs",
            expandAll: false,
            items: this.props.availableFields.childs,
            name: Resources.Common.sortSecondColumnLabel,
            disableSort: true,
            selectedValue: this.props.model?.sortSecond,
            onChange: this.onSecondChange
        }
        this.dropdownSecond = new DropDownComponent(dropdownSecondProps);

        this.element = <div className="gridview-select-sort">
            <div className="sorts">
                <div className="sort">

                    {this.dropdownFirst.render()}
                    <RadioButtonComponent
                        model={this.props.model}
                        field="sortFirstAsc"
                        options={[
                            { description: `${Resources.Common.sortTypeDesc}`, value: 0 },
                            { description: `${Resources.Common.sortTypeAsc}`, value: 1 }
                        ]}
                        inline={false}
                        name=""
                        changeEvent={this.onSortTypeSelected}
                        additionalCssClasses="sort-first" />

                    {this.dropdownSecond.render()}
                    <RadioButtonComponent
                        model={this.props.model}
                        field="sortSecondAsc"
                        options={[
                            { description: `${Resources.Common.sortTypeDesc}`, value: 0 },
                            { description: `${Resources.Common.sortTypeAsc}`, value: 1 }
                        ]}
                        inline={false}
                        name=""
                        changeEvent={this.onSortTypeSelected}
                        additionalCssClasses="sort-second" />
                </div>
            </div>
        </div>
    }

    render() {
        this.getElement();
        return this.element;
    }
}